export function getFixedLeftPositionWorklet({
  positionX,
  unitSize,
  columnHorizontalPadding,
  scrollX,
  margin,
}: {
  positionX: number;
  unitSize: number;
  margin: number;
  columnHorizontalPadding: number;
  scrollX: number;
}) {
  "worklet";
  return (
    positionX * (unitSize + columnHorizontalPadding / 2) +
    (positionX % 2 === 0 ? columnHorizontalPadding / 2 : 0) +
    margin -
    scrollX
  );
}
